import { render, staticRenderFns } from "./payment-frame.vue?vue&type=template&id=f18a7748&scoped=true"
import script from "./payment-frame.vue?vue&type=script&lang=js"
export * from "./payment-frame.vue?vue&type=script&lang=js"
import style0 from "./payment-frame.vue?vue&type=style&index=0&id=f18a7748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18a7748",
  null
  
)

export default component.exports